export enum SentType {
  Automatic = 1,
  ByUser = 2,
  None = 3,
}
